import React from "react"
import { Redirect } from "react-router-dom"
import { ConsumerCarrotRxPage } from "#/pages/consumer/carrot-rx/page"
import { DbgPaths, Paths } from "#/utils/Paths"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { PageLoading } from "#/features/global-ui/page-layout"

// Only redirect to the pharmacy benefit once a non-consumer program is confirmed. With no answer at
// all, go home rather than spin forever.
export function CarrotRxRoute(): JSX.Element {
  const { data: programFlags, isError } = useMemberProgramFlags()
  if (!programFlags) return isError ? <Redirect to={Paths.HOME} /> : <PageLoading />
  return programFlags.isConsumer ? <ConsumerCarrotRxPage /> : <Redirect to={DbgPaths.PHARMACY} />
}
